<template>
    <div class="editor-tools-wrapper">
        <div class="editor-default-tools">
            <div class="editor-tool-wrapper" v-for="(tool, index) in tools" :key="index"
                @mousedown="dradObjectStart($event, index, 'default')" :class="{ dim: tool.isHidded }">
                <div class="editor-tool-container" :class="{ hide: tool.isHidded }">
                    <img :src="tool.toolIcon">
                </div>
                <div class="editor-tool-footer" :class="{ hide: tool.isHidded }">
                    {{ tool.toolName }}
                </div>
            </div>
        </div>
        <div class="editor-custom-tools">
            <div class="editor-custom-tools-header">
                Saved Components
            </div>

            <div class="editor-custom-tools-body">

                <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading"
                    :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>

                <div class="editor-custom-tool-item" v-for="(item, index) in customTools" :key="index">
                    <div class="editor-custom-tool-item-header">
                        <div class="editor-custom-tool-label">
                            {{ item.title }}
                        </div>
                        <div class="editor-custom-tool-options">
                            <widgetDropdown v-model="item.showMenu" :right="true" :hover="false" :interactive="true">
                                <button class="btn-dropdown btn-menu">
                                    <img class="icon" style="height: 15px"
                                        src="@/assets/cv-editor-icons/menu-dot-gray.svg" />
                                </button>
                                <div slot="dropdown" class="dropdown-widget" style="right: -9px">
                                    <app-dialog title="Delete Component"
                                        ask="Are you sure you want to permanently delete this component?" yesText="Delete"
                                        noText="Cancel" @onComfirm="deleteComponent(item)">
                                        <a class="dropdown-item" href="#">Delete </a>
                                    </app-dialog>
                                </div>
                            </widgetDropdown>
                        </div>
                    </div>
                    <div class="editor-custom-tool-item-body" @mousedown="dradObjectStart($event, index, 'custom')">
                        <img :src="$fullUrl('images/profiles/') + item.file">
                    </div>
                </div>
            </div>
        </div>
        <!-- Drad Default Element Guost  -->
        <div class="editor-tool-wrapper-guost" v-show="!guostElement.isHidded" :style="{
            top: guostElement.y + 'px',
            left: guostElement.x + 'px',
        }" :class="{ guostOnPage: isPageHover }">
            <div class="editor-tool-container" v-if="guostElement.el">
                <div class="editor-tool-content" v-if="guostElement.origin == 'custom'">
                    <img :src="$fullUrl('images/profiles/') + guostElement.el.file">
                </div>
                <div class="editor-tool-content" v-else>
                    {{ guostElement.el.toolName }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-template-tools",
    components: {},
    props: {
        isPageHover: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            test_val: false,
            guostElement: {
                origin: 'default',
                el: null,
                isHidded: true,
                x: 0,
                y: 0,
            },
            selectedToolIndex: null,
            tools: [
                {
                    toolName: 'Section',
                    toolType: 'section_tool',
                    toolIcon: require('../icons/tools/section.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Box',
                    toolType: 'box_tool',
                    toolIcon: require('../icons/tools/box.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Title',
                    toolType: 'title_tool',
                    toolIcon: require('../icons/tools/title.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Paragraph',
                    toolType: 'text_tool',
                    toolIcon: require('../icons/tools/paragraph.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Image',
                    toolType: 'image_tool',
                    toolIcon: require('../icons/tools/image.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Line',
                    toolType: 'line_tool',
                    toolIcon: require('../icons/tools/line.svg'),
                    isHidded: false,
                },
                {
                    toolName: 'Stars',
                    toolType: 'star_tool',
                    toolIcon: require('../icons/tools/stars.svg'),
                    isHidded: false,
                }
            ],
            customTools: [],
            is_loading: false
        };
    },
    computed: {

    },
    watch: {},
    mounted() {
        let vm = this;
        vm.getCustomComponents();
        eventBus.$on("onSaveNodeComponentSuccess", (data) => {
            vm.getCustomComponents();
        });
    },
    methods: {
        getCustomComponents() {
            let vm = this;
            vm.is_loading = true;
            vm.$store
                .dispatch("CVS_GET_TEMPLATE_COMPONENTS")
                .then((response) => {
                    vm.is_loading = false;
                    vm.customTools = response.data.map(item => {
                        item.showMenu = false;
                        return item;
                    });
                })
                .catch((error) => {
                    vm.is_loading = false;
                    console.error({ error });
                });
        },
        deleteComponent(item) {
            let vm = this;
            vm.$store
                .dispatch("CVS_DELETE_TEMPLATE_COMPONENT", { id: item.id })
                .then((response) => {
                    vm.getCustomComponents();
                    vm.$notify({
                        group: "status",
                        title: "Messsage",
                        text: "Component deleted successfully",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        dradObjectStart(e, index, type) {
            e.preventDefault();
            let vm = this;

            vm.guostElement = {
                origin: 'default',
                el: null,
                isHidded: true,
                x: 0,
                y: 0,
            };
            if (type == 'default') {
                vm.guostElement.origin = 'default';
                vm.tools[index].isHidded = true;
                vm.guostElement.isHidded = false;
                vm.guostElement.el = vm.tools[index];
                vm.selectedToolIndex = index;
                vm.$emit('onToolSelected', {
                    tool: vm.tools[index],
                    origin: 'default'
                });
            } else {
                vm.guostElement.origin = 'custom';
                vm.customTools[index].isHidded = true;
                vm.guostElement.isHidded = false;
                vm.guostElement.el = vm.customTools[index];
                vm.selectedToolIndex = index;
                vm.$emit('onToolSelected', {
                    tool: JSON.parse(vm.guostElement.el.component),
                    origin: 'custom'
                });
            }
            document.onmouseup = vm.dragObjectEnd;
            document.onmousemove = vm.onElementDrag;
        },
        onElementDrag(e) {
            e.preventDefault();
            let vm = this;
            let goustElement = document.querySelector('.editor-tool-wrapper-guost');
            let goustElementRect = goustElement.getBoundingClientRect();
            let goustElementWidth = goustElementRect.width;
            let goustElementHalfWidth = (goustElementWidth / 2) - 15;
            let goustElementHeight = goustElementRect.height;
            let goustElementHalfHeight = (goustElementHeight / 2) - 15;
            vm.guostElement.x = e.clientX - goustElementHalfWidth;
            vm.guostElement.y = e.clientY - goustElementHalfHeight;
        },
        dragObjectEnd(e) {
            let vm = this;
            vm.tools[vm.selectedToolIndex].isHidded = false;
            vm.guostElement.isHidded = true;
            vm.$emit('onToolSelected', null);
            document.onmouseup = null;
            document.onmousemove = null;
        },

    },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.editor-tools-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-y: auto;

    .editor-default-tools {
        display: grid;
        grid-template-columns: calc(33% - 4px) calc(33% - 4px) calc(33% - 4px);
        grid-gap: 8px;
        padding: 5px;

        .editor-tool-wrapper {
            padding: 10px 0px;
            border-radius: 5px;
            border: 1px solid #424242;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            cursor: pointer;
            transition: all 50ms ease-out;
            opacity: 1;

            &:hover {
                background: #ebebeb;
            }

            &.dim {
                opacity: 0.3;
                transition: all 50ms ease-out;
            }

            .editor-tool-container {
                opacity: 1;
                transition: all 50ms ease-out;
                padding: 0px 10px;

                img {
                    width: 100%;
                    height: 25px;
                }

                &.hide {
                    opacity: 0;
                    transition: all 50ms ease-in;
                }
            }

            .editor-tool-footer {
                opacity: 1;
                transition: all 50ms ease-out;

                &.hide {
                    opacity: 0;
                    transition: all 50ms ease-in;
                }
            }


        }
    }

    .editor-custom-tools {
        .editor-custom-tools-header {
            padding: 10px;
            background-color: #dfdfdf;
            color: #616161;
            font-size: 14px;
            font-weight: 600;
        }

        .editor-custom-tools-body {
            padding: 5px;
            position: relative;
            min-height: 300px;

            .editor-custom-tool-item {
                border: 1px solid #e0e0e0;
                padding: 5px;
                border-radius: 5px;
                margin-bottom: 8px;

                .editor-custom-tool-item-header {
                    display: flex;
                    justify-content: space-between;
                    padding: 5px 0px;
                }

                .editor-custom-tool-item-body {
                    padding: 5px 0px;

                    img {
                        width: 100%;
                        height: 80px;
                        object-fit: contain;
                    }
                }
            }
        }
    }

    .editor-tool-wrapper-guost {
        position: fixed;
        z-index: 999999999;
        scale: 1;
        transition: scale 200ms ease-out;
        // stop user select
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        // stop event
        pointer-events: none;
        background-color: #a7a7a7;
        padding: 3px;

        &.guostOnPage {
            scale: 2;
            transition: scale 200ms ease-in;
        }

        .editor-tool-container {
            .editor-tool-content {
                color: #fff;

                img {
                    width: 200px;
                    height: 50px;
                    object-fit: contain;
                }
            }
        }
    }
}
</style>